import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dc123722")

_pushScopeId("data-v-dc123722")
const _hoisted_1 = { class: "InvoiceDestinations" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "InvoiceDestinations__title" }, "Пункты назначения", -1)
const _hoisted_3 = {
  key: 0,
  class: "FilesLoader"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "state--text text--loading" }, "Загрузка файлов...", -1)
const _hoisted_5 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_invoice_destination = _resolveComponent("invoice-destination")!
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_uploaded_file = _resolveComponent("uploaded-file")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_invoice_destination, {
      title: "Отправитель",
      destination: _ctx.invoiceState.data.sender,
      "additional-services": _ctx.invoiceState.data.order_additional_services,
      "new-additional-services": _ctx.invoiceState.data.order_additional_services_values
    }, null, 8, ["destination", "additional-services", "new-additional-services"]),
    _createVNode(_component_invoice_destination, {
      title: "Получатель",
      destination: _ctx.invoiceState.data.receiver,
      "is-pvz": _ctx.invoiceState.data.is_pvz_invoice,
      "distribution-center-id": _ctx.invoiceState.data.receiver.distribution_center_id,
      "additional-services": _ctx.invoiceState.data.additional_services,
      "new-additional-services": _ctx.invoiceState.data.additional_services_values
    }, null, 8, ["destination", "is-pvz", "distribution-center-id", "additional-services", "new-additional-services"]),
    (_ctx.state.is_loading)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_s_loader),
          _hoisted_4
        ]))
      : (Boolean(_ctx.state.softPackage.length || _ctx.state.grid.length))
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_uploaded_file, {
              "is-visible": Boolean(_ctx.state.softPackage.length),
              files: _ctx.state.softPackage,
              loading: _ctx.state.is_loading,
              title: "Мягкая упаковка",
              "no-delete": "",
              "is-white": "",
              style: { marginTop: '20px' }
            }, null, 8, ["is-visible", "files", "loading"]),
            _createVNode(_component_uploaded_file, {
              "is-visible": Boolean(_ctx.state.grid.length),
              files: _ctx.state.grid,
              loading: _ctx.state.is_loading,
              title: "Обрешетка",
              "no-delete": "",
              "is-white": "",
              style: { marginTop: '20px' }
            }, null, 8, ["is-visible", "files", "loading"])
          ]))
        : _createCommentVNode("", true)
  ]))
})